import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import {
  loadingToggleAction, loginAction,
} from '../../store/actions/AuthActions';
import LoginLeftPanel from './LoginLeftPanel';

const backendUrl = process.env.REACT_APP_BACKEND;

function Login(props) {
  const [username, setUsername] = useState('');
  let errorsObj = { username: '', password: '' };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate()

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (username === '') {
      errorObj.username = 'Nombre de usuario es requerido';
      error = true;
    }
    if (password === '') {
      errorObj.password = 'Contraseña es requerida';
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    dispatch(loadingToggleAction(true));
    dispatch(loginAction(username, password, navigate));
  }

  const [leftPanelData, setLeftPanelData] = useState({
    data: ''
  });

  useEffect(() => {
    fetch(`${backendUrl}/api/public/v3/login/pizarra/`)
      .then(response => response.json())
      .then(data => setLeftPanelData(data))
      .catch(error => console.error('Error al obtener datos:', error));
  }, []);

  return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">

      <LoginLeftPanel data={leftPanelData.results} />

      <div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="authincation-content style-2">
            <div className="row no-gutters">
              <div className="col-xl-12 tab-content">
                <div id="sign-in" className="auth-form form-validation">
                  {props.errorMessage && (
                    <div className='bg-red-300 text-red-900 border border-red-900 p-1 my-2'>
                      {props.errorMessage}
                    </div>
                  )}
                  {props.successMessage && (
                    <div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
                      {props.successMessage}
                    </div>
                  )}
                  <form onSubmit={onLogin} className="form-validate">
                    <h3 className="text-center mb-4 text-black">Accede a tu cuenta</h3>
                    <div className="form-group mb-3">
                      <label className="mb-1" htmlFor="val-username"><strong>Nombre de usuario</strong></label>
                      <div>
                        <input type="username" className="form-control"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Escribe tu nombre de usuario"
                        />
                      </div>
                      {errors.username && <div className="text-danger fs-12">{errors.username}</div>}
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1"><strong>Contraseña</strong></label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        placeholder="Escribe tu contraseña"
                        onChange={(e) =>
                          setPassword(e.target.value)
                        }
                      />
                      {errors.password && <div className="text-danger fs-12">{errors.password}</div>}
                    </div>
                    <div className="text-center form-group mb-3">
                      <button type="submit" className="btn btn-primary btn-block" disabled={props.showLoading}>
                        {props.showLoading ? 'Loading...' : 'Iniciar sesión'}
                      </button>
                    </div>
                  </form>
									<div className="new-account mt-3">
										<p>¿Olvidaste la contraseña? <Link className="text-primary" to="/page-forgot-password">Recuperar</Link></p>
									</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
